import { render, staticRenderFns } from "./VehiclesCrud.vue?vue&type=template&id=9a866d90"
import script from "./VehiclesCrud.vue?vue&type=script&lang=js"
export * from "./VehiclesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports